import { defineMessages } from 'react-intl';

export default defineMessages({
  shareVideo: {
    id: 'widget.share-video.share',
    defaultMessage: 'Share Video',
  },
  shareChannel: {
    id: 'widget.share-channel.share',
    defaultMessage: 'Share Channel',
  },
});



// WEBPACK FOOTER //
// ./src/widget/components/share-mobile/translations.js